import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  cloudChiprApi,
  ResourceFilters,
  ResourceType,
} from "../../../../services/cloudchipr.api";
import { getResourceGridDataFixedCacheKey } from "../../utils/helpers/fixedCacheKeys";
import { generateKubernetesFilterTreeByFilters } from "@/store/kubernetes-live-usage-mgmt/thunks/resources/utils/helpers/generateKubernetesFilterTreeByFilters";
import { kubernetesResourceTypes } from "@/store/resources-grid/utils/constants/common";

type GetGridResourceDataThunkArgs = {
  resourceType: ResourceType;
  account_ids: string[];
  resourceFilters: ResourceFilters;
  masterGridId: string;
};

export const getGridResourceDataThunk = createAsyncThunk(
  "resourcesGrid/getGridResourceData",
  async (
    {
      resourceType,
      resourceFilters,
      account_ids,
      masterGridId,
    }: GetGridResourceDataThunkArgs,
    { dispatch },
  ) => {
    const {
      postUsersMeOrganisationsCurrentKubernetesByTypeResources,
      postUsersMeV2OrganisationsCurrentByTypeResources,
    } = cloudChiprApi.endpoints;

    if (kubernetesResourceTypes.has(resourceType)) {
      return await dispatch(
        postUsersMeOrganisationsCurrentKubernetesByTypeResources.initiate(
          {
            type: resourceType,
            body: {
              filter: generateKubernetesFilterTreeByFilters({
                filter: resourceFilters,
                clusterIds: account_ids ?? [],
              }),
            },
          },
          { fixedCacheKey: getResourceGridDataFixedCacheKey(masterGridId) },
        ),
      ).unwrap();
    }

    return await dispatch(
      postUsersMeV2OrganisationsCurrentByTypeResources.initiate(
        {
          type: resourceType,
          body: {
            account_ids,
            filter: resourceFilters,
          },
        },
        { fixedCacheKey: getResourceGridDataFixedCacheKey(masterGridId) },
      ),
    ).unwrap();
  },
);
